import type { CoreFetch } from '~/types/CoreFetch'
import type { InfluencerRecentOpportunities } from '~/types/influencer'

export function provideFetchRecentOpportunities(
  coreFetch: CoreFetch,
  slug: string,
) {
  return function (): Promise<InfluencerRecentOpportunities[]> {
    return coreFetch.$get(`/influencer/profile/${slug}/recent_opportunities/`)
  }
}
